import { useEditor, useSmartProp } from '@smartfire/glue-ui/block';
import { EditableText } from '@smartfire/components';
import { Search, Tile } from '../';
import { Map } from 'mapbox-gl';
import Link from 'src/components/Link';
import { GetClosestStoreType } from '../Controller';
import type Store from 'src/api/public/Store';
import { ReactComponent as MapIcon } from 'src/assets/icons/map.svg';
import clsx from 'clsx';
import style from './style.module.scss';

interface HeaderProps extends React.HTMLAttributes<HTMLElement> {
    map: Map | null;
    getClosestStore: GetClosestStoreType;
    store?: Store | null;
}

export const Header: React.FC<HeaderProps> = ({ map, getClosestStore, store, ...props }) => {
    const [title] = useSmartProp('title');
    const [description] = useSmartProp('title');
    const [linkAll] = useSmartProp('linkAll');
    const { isEditing } = useEditor();
    return (
        <header className={clsx(style.mapHeader, props.className)}>
            <div className={style.head}>
                <div className={style.headContainer}>
                    {(title || isEditing) && (
                        <h2 className={style.title}>
                            <MapIcon className={style.icon} />
                            <EditableText smartProp="title" placeholder="Titre" />
                        </h2>
                    )}
                    {linkAll && (
                        <Link to={linkAll ? linkAll : ''} color="white">
                            <EditableText smartProp="linkText" placeholder="Texte du lien" />
                        </Link>
                    )}
                </div>
                {(description || isEditing) && (
                    <EditableText
                        className={style.description}
                        tagName="p"
                        smartProp="description"
                        placeholder="Description"
                    />
                )}
            </div>
            <div className={style.container}>
                <Search map={map} getClosestStore={getClosestStore} className={style.searchBar} />
                {store && (
                    <div className={style.tileContainer}>
                        <Tile isMain={false} store={store} className={style.tile} />
                    </div>
                )}
            </div>
        </header>
    );
};
